module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-back",
    staticStyle: {
      "padding": ".2rem 0 1rem 0",
      "height": "100%"
    }
  }, [_c('van-cell-group', [_c('van-cell', {
    attrs: {
      "title": "秩序册信息",
      "is-link": ""
    },
    on: {
      "click": function($event) {
        return _vm.goto(1)
      }
    }
  }, [(_vm.pageData.confirm_1 == 2) ? _c('van-tag', {
    attrs: {
      "type": "danger"
    }
  }, [_vm._v("待确认")]) : _c('van-tag', {
    attrs: {
      "plain": "",
      "type": "success"
    }
  }, [_vm._v("已确认")])], 1), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "项目信息",
      "is-link": ""
    },
    on: {
      "click": function($event) {
        return _vm.goto(2)
      }
    }
  }, [(_vm.pageData.confirm_2 == 2) ? _c('van-tag', {
    attrs: {
      "type": "danger"
    }
  }, [_vm._v("待确认")]) : _c('van-tag', {
    attrs: {
      "plain": "",
      "type": "success"
    }
  }, [_vm._v("已确认")])], 1), _vm._v(" "), (_vm.pageData.need_shisu == 1) ? _c('van-cell', {
    attrs: {
      "title": "食宿信息",
      "is-link": ""
    },
    on: {
      "click": function($event) {
        return _vm.goto(3)
      }
    }
  }, [(_vm.pageData.confirm_3 == 2) ? _c('van-tag', {
    attrs: {
      "type": "danger"
    }
  }, [_vm._v("待确认")]) : _c('van-tag', {
    attrs: {
      "plain": "",
      "type": "success"
    }
  }, [_vm._v("已确认")])], 1) : _vm._e(), _vm._v(" "), (_vm.pageData.need_shisu == 1 && _vm.pageData.trans_station_setting) ? _c('van-cell', {
    attrs: {
      "title": "到达酒店时间",
      "is-link": ""
    },
    on: {
      "click": function($event) {
        return _vm.goto(4)
      }
    }
  }, [(_vm.pageData.confirm_4 == 2) ? _c('van-tag', {
    attrs: {
      "type": "danger"
    }
  }, [_vm._v("完善到达酒店时间")]) : (_vm.pageData.confirm_4 == 3) ? _c('van-tag', {
    attrs: {
      "type": "danger"
    }
  }, [_vm._v("待确认")]) : (_vm.pageData.confirm_4 == 1) ? _c('van-tag', {
    attrs: {
      "plain": "",
      "type": "success"
    }
  }, [_vm._v("已确认")]) : _c('van-tag', {
    attrs: {
      "plain": ""
    }
  }, [_vm._v("不需要")])], 1) : _vm._e(), _vm._v(" "), (_vm.pageData.need_shisu == 1 && _vm.pageData.trans_station_setting) ? _c('van-cell', {
    attrs: {
      "title": "离开酒店时间",
      "is-link": ""
    },
    on: {
      "click": function($event) {
        return _vm.goto(5)
      }
    }
  }, [(_vm.pageData.confirm_5 == 2) ? _c('van-tag', {
    attrs: {
      "type": "danger"
    }
  }, [_vm._v("完善离开酒店时间")]) : (_vm.pageData.confirm_5 == 3) ? _c('van-tag', {
    attrs: {
      "type": "danger"
    }
  }, [_vm._v("待确认")]) : (_vm.pageData.confirm_5 == 1) ? _c('van-tag', {
    attrs: {
      "plain": "",
      "type": "success"
    }
  }, [_vm._v("已确认")]) : _c('van-tag', {
    attrs: {
      "plain": ""
    }
  }, [_vm._v("不需要")])], 1) : _vm._e(), _vm._v(" "), (_vm.pageData.need_shisu == 1) ? _c('van-cell', {
    attrs: {
      "title": "用餐信息",
      "is-link": ""
    },
    on: {
      "click": function($event) {
        return _vm.goto(6)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageData.kantaibaoming_url) ? _c('van-cell', {
    attrs: {
      "title": "看台啦啦操报名",
      "is-link": ""
    },
    on: {
      "click": function($event) {
        return _vm.ktllc()
      }
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('LoginDialog', {
    attrs: {
      "show": _vm.loginShow
    },
    on: {
      "loginSuccess": _vm.loginSuccess,
      "loginCancel": _vm.loginCancel
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0d5eef39","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/sai/saiConfirm.vue
// module id = 2206
// module chunks = 0